<div class="cmx-form-group">
  <div class="cmx-form-control--icon-button-trail">
    <cwc-input class="width-full" [(ngModel)]="searchTerm" designVersion="v2" type="text" placeholder="{{translationService.pt(placeholder)}}"
    trailingIcon="search" (cwcChange)="onSearchClicked()" attr.data-tid="cmx-input-search-{{templateId}}" (keyup)="onSearchTermChanged()">
    </cwc-input>
  </div>
</div>
